export enum CycleCountRuleStatus {
  Live = "live",
  Disabled = "disabled",
  Draft = "draft",
}
